<template>
    <svg height="20" viewBox="0 0 20.707 23.664" width="20" xmlns="http://www.w3.org/2000/svg">
        <path
            id="Icon_awesome-user-secret"
            d="M17.744,14.25l1.1-2.893a.739.739,0,0,0-.693-1h-2.7A5.861,5.861,0,0,0,16.274,7.4V7.382c1.812-.361,2.958-.883,2.958-1.465,0-.615-1.262-1.16-3.24-1.525A11.99,11.99,0,0,0,14.116.564,1.484,1.484,0,0,0,12.29.158L11.014.8A1.478,1.478,0,0,1,9.693.8L8.417.158A1.484,1.484,0,0,0,6.591.564,12.087,12.087,0,0,0,4.715,4.391c-1.974.365-3.235.911-3.235,1.525,0,.582,1.146,1.1,2.958,1.465V7.4a5.861,5.861,0,0,0,.823,2.958H2.6a.739.739,0,0,0-.679,1.031l1.193,2.783A6.192,6.192,0,0,0,0,19.524v2.071a2.073,2.073,0,0,0,2.071,2.071H18.636a2.073,2.073,0,0,0,2.071-2.071V19.524a6.194,6.194,0,0,0-2.963-5.274ZM8.135,22.186,6.212,13.312,8.5,14.791,9.614,16.64Zm4.437,0L11.093,16.64,12.2,14.791l2.293-1.479ZM14.5,8.389a3.4,3.4,0,0,1-.763,1.544c-.467.43-2.219,1.035-2.958-1.156a.453.453,0,0,0-.846,0c-.786,2.32-2.588,1.5-2.958,1.156a3.354,3.354,0,0,1-.763-1.544c-.037-.116-.291-.263-.291-.268v-.5a35.594,35.594,0,0,0,4.437.268A34.729,34.729,0,0,0,14.8,7.622v.5S14.537,8.269,14.5,8.389Z"
            data-name="Icon awesome-user-secret"
            fill="#afafaf"
            transform="translate(0 -0.001)"
        />
    </svg>
</template>

<script>
export default {
    name: "PrivateMessage",
};
</script>
